module.exports = "<div> <div class=\"media-wrapper video clearfix\"> <div class=video-gallery> <div class=col-xs-12> <div class=\"embed-responsive embed-responsive-16by9\"> <iframe width=\"\" height=\"\" ng-src={{::playbackUrl}} frameborder=0 allowfullscreen=\"\"></iframe> </div> </div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./web/js/module/practicalExample/js/video/video.html
// module id = 1123
// module chunks = 0